<div class="dialog">
  <h4 mat-dialog-title>{{ 'common_modify' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data.produits">
    <mat-form-field>
      <mat-label>{{ 'common_field_transport' | translate }}</mat-label>
      <mat-select class="panel-override" name="transportName" [value]="data?.produits.transportId || '0'" (selectionChange)="selectChange($event.value)">
        <mat-option value="0">{{ 'common_no_transport' | translate }}</mat-option>
        <mat-option *ngFor="let t of data.transports" [value]="t.resourceId">{{ t?.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox class="doubleCargo" *ngIf="transportFamilyCode == FamilyCodes.RoadTransportCode" [(ngModel)]="data?.produits.doubleCargo" name="doubleCargo">{{ 'common_double_freight' | translate }}</mat-checkbox>
    <mat-form-field>
      <mat-label>{{ 'common_field_distance' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produits.distance" name="distance" min="0" cdkFocusInitial required />
      <mat-error *ngIf="!data?.produits.distance" [innerHTML]="'common_error_distance_required' | translate"></mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="transportFamilyCode == FamilyCodes.RoadTransportCode">
      <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
      <mat-select name="energyName" [value]="data?.produits.energyId || '0'" (selectionChange)="selectEnergieChange($event.value)">
        <mat-option *ngFor="let e of data.energies" [value]="e.resourceId">{{ e?.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="displayForComplexProduct == false">
      <mat-label>{{ 'dialog_edit_composition_field_ratio' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produits.ratio" name="ratio" #ratio="ngModel" min="0" required />
      <mat-error *ngIf="ratio.errors?.required" [innerHTML]="'dialog_edit_composition_error_ratio' | translate"></mat-error>
      <mat-error *ngIf="ratio.errors?.min" [innerHTML]="'dialog_edit_composition_error_ratio_negative' | translate"></mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="displayForComplexProduct == true">
      <mat-label>{{ 'common_field_quantity' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data?.produits.quantity" name="quantity" required />
      <mat-error *ngIf="!data?.produits.quantity" [innerHTML]="'common_error_quantity_required_alt' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data.produits" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
